import { SoilAnalysis } from '../models/soil-analysis.model';

enum SortOrder {
  Asc = 1,
  Desc = -1,
}

export class SoilAnalysisSortHelper {
  static sortAsc(soilAnalysis: SoilAnalysis[]): SoilAnalysis[] {
    return this.sort(soilAnalysis, SortOrder.Asc);
  }

  static sortDesc(soilAnalysis: SoilAnalysis[]): SoilAnalysis[] {
    return this.sort(soilAnalysis, SortOrder.Desc);
  }

  private static sort(soilAnalysis: SoilAnalysis[], sortOrder: SortOrder): SoilAnalysis[] {
    return soilAnalysis.slice().sort((a, b) => {
      const aYear = Number(a?.samplingDateTime?.substring(0, 4));
      const bYear = Number(b?.samplingDateTime?.substring(0, 4));

      if (!a?.description || !b?.description || !aYear || !bYear) {
        return 0;
      }

      if (aYear !== bYear) {
        return (aYear - bYear) * sortOrder;
      }

      // Description comparison is always ascending
      return a.description.localeCompare(b.description, undefined, {
        sensitivity: 'base',
      });
    });
  }
}
